import { UseFormReturn, useWatch } from 'react-hook-form';
import { BoloPanelFormType } from '@mark43/cad-api';
import { Radio } from '@cad-arc';

export type BoloPanelFormIsPrimaryCheckProps = {
    form: UseFormReturn<BoloPanelFormType>;
    basePath: 'involvedPersons' | 'involvedVehicles';
    index: number;
};

export const BoloPanelFormIsPrimaryCheck = ({
    form,
    basePath,
    index,
}: BoloPanelFormIsPrimaryCheckProps) => {
    const isSelected = useWatch({
        control: form.control,
        name: `${basePath}.${index}.isPrimary`,
    });

    const onPrimarySet = () => {
        const otherPrimaryPersons = form.getValues('involvedPersons').length;
        const otherPrimaryVehicles = form.getValues('involvedVehicles').length;

        for (let i = 0; i < otherPrimaryPersons; i++) {
            const isCurrentPerson = basePath === 'involvedPersons' && i === index;
            form.setValue(`involvedPersons.${i}.isPrimary`, isCurrentPerson, { shouldDirty: true });
        }

        for (let i = 0; i < otherPrimaryVehicles; i++) {
            const isCurrentVehicle = basePath === 'involvedVehicles' && i === index;
            form.setValue(`involvedVehicles.${i}.isPrimary`, isCurrentVehicle, {
                shouldDirty: true,
            });
        }
    };

    return (
        <Radio isChecked={isSelected} onChange={onPrimarySet}>
            Primary Subject
        </Radio>
    );
};
